import { getCurrentQuery } from "../../utils.js";
import { dialogAnimate } from "../../validation.js";

export function accountDeleted() {
    const accDeletedQuery = getCurrentQuery().find(item => item.acc_deleted)?.acc_deleted;
    if(!accDeletedQuery) return;
    dialogAnimate('account_deleted');
}